export const small = 480;
export const medium = 768;
export const large = 1280;

export const breakpoints: { [key: string]: number } = {
  large,
  medium,
  small,
};
